export enum PATH {
    LOGIN = '/login',
    WEBINARS = '/webinars',
}
